module.exports = __webpack_public_path__ + "static/media/FastFeedback_head_portal_h294px_Artboard_2-06.180ad092.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FastFeedback_head_portal_h294px_Artboard_2-06.png
// module id = 446
// module chunks = 0